/**
 * I dizionari della console, sempre in coppia it/en (la prova `parita.test.ts` verifica che i due alberi restino
 * gemelli). La console li usa dal 19/10/2026, a partire dalle pagine del programma partner: le pagine più vecchie
 * hanno ancora i testi nel codice, e si spostano qui quando si toccano.
 */
import partnerIt from './locales/partner/it';
import partnerEn from './locales/partner/en';
import crmIt from './locales/crm/it';
import crmEn from './locales/crm/en';
import reteIt from './locales/rete/it';
import reteEn from './locales/rete/en';
import aziendeIt from './locales/aziende/it';
import aziendeEn from './locales/aziende/en';
import mappaIt from './locales/mappa/it';
import mappaEn from './locales/mappa/en';
import menuIt from './locales/menu/it';
import menuEn from './locales/menu/en';
import listiniIt from './locales/listini/it';
import listiniEn from './locales/listini/en';
import fornitoriIt from './locales/fornitori/it';
import fornitoriEn from './locales/fornitori/en';
import yumaSitoIt from './locales/yumaSito/it';
import yumaSitoEn from './locales/yumaSito/en';

export const RISORSE = {
  it: { partner: partnerIt, crm: crmIt, rete: reteIt, aziende: aziendeIt, mappa: mappaIt, menu: menuIt, listini: listiniIt, fornitori: fornitoriIt, yumaSito: yumaSitoIt },
  en: { partner: partnerEn, crm: crmEn, rete: reteEn, aziende: aziendeEn, mappa: mappaEn, menu: menuEn, listini: listiniEn, fornitori: fornitoriEn, yumaSito: yumaSitoEn },
} as const;

export const LINGUE = ['it', 'en'] as const;
export type Lingua = (typeof LINGUE)[number];
